export const serverStatus = "Live";

export const serverLink =
  serverStatus === "Dev" ? "http://localhost:4480/" : "https://aum.gargatechapi.com.ng/"

export const projectName = "Al-Ansar University";
export const projectCode = "BABA_AHMED_UNIVERSITY";
export const projectLogo = "https://aum.edu.ng/logo.png";
export const projectNameOfficialEmail = "aum.edu.ng";